var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 6.73684V3.36842H13.6V6.73684H20.4ZM3.4 10.1053V28.6316H30.6V10.1053H3.4ZM30.6 6.73684C32.487 6.73684 34 8.23579 34 10.1053V28.6316C34 30.5011 32.487 32 30.6 32H3.4C1.513 32 0 30.5011 0 28.6316L0.017 10.1053C0.017 8.23579 1.513 6.73684 3.4 6.73684H10.2V3.36842C10.2 1.49895 11.713 0 13.6 0H20.4C22.287 0 23.8 1.49895 23.8 3.36842V6.73684H30.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.0992f955b1bfb7308e71246a7c240729.svg";
export { ForwardRef as ReactComponent };